import React from 'react';
import { Link } from 'react-router-dom';
import './DrawerMenu.css';
import {useAppState} from "../../store/useAppState";

interface DrawerMenuProps {
    isOpen: boolean;
    onClose: () => void;
}

const menuItems = [
    { path: '/terms', label: 'Terms & Conditions' },
    { path: '/privacy', label: 'Privacy Policy' },
    { path: '/subscription-terms', label: 'Subscription Terms' },
    { path: '/support', label: 'Support Center' },
];

const DrawerMenu: React.FC<DrawerMenuProps> = ({ isOpen, onClose }) => {
    const { isDrawerMenuOpen, changeDrawerMenuState } = useAppState();
    return (
        <div className={`drawer-menu ${isDrawerMenuOpen ? 'drawer-menu--open' : ''}`}>
            <div className="drawer-menu__overlay" onClick={() => {
                changeDrawerMenuState(false)
            }} />
            <div className="drawer-menu__content">
                <div className="drawer-menu__header">
                    <img src={process.env.PUBLIC_URL + '/images/logo-full.png'} alt="aiCourses Logo" className="drawer-menu__logo" />
                    <button className="drawer-menu__close" onClick={() => {
                        changeDrawerMenuState(false)
                    }}>
                        ×
                    </button>
                </div>
                <div className="drawer-menu__header-separator" />
                <nav className="drawer-menu__nav">
                    {menuItems.map((item, idx) => (
                        <React.Fragment key={item.path}>
                            <Link
                                to={item.path}
                                className="drawer-menu__item"
                                onClick={() => {
                                    changeDrawerMenuState(false)
                                }}
                            >
                                {item.label}
                            </Link>
                            {idx < menuItems.length - 1 && <div className="drawer-menu__separator" />}
                        </React.Fragment>
                    ))}
                </nav>
            </div>
        </div>
    );
};

export default DrawerMenu;
